<div
  class="dropdown dropdown-engine ea-dropdown"
  #dropdown
  (mouseenter)="openDropdown()"
  (mouseleave)="triggerOut()"
>
  <a
    href="#"
    class="dropdown-toggle"
    data-toggle="dropdown"
    role="button"
    aria-haspopup="true"
    aria-expanded="false"
  >
    <svg-icon-sprite
      src="assets/svg/sprite.svg#{{
        iconHorizontal ? 'more-horizontal' : 'more-vertical'
      }}"
      [viewBox]="'0 0 24 24'"
      [width]="iconWidth"
      [classes]="'pull-right'"
    ></svg-icon-sprite>
  </a>

  <ul
    class="dropdown-menu"
    [class.dropdown-menu-lg-right]="alignRight"
    [class.dropdown-menu-no-offset]="noOffset"
    (mouseenter)="cancelTimeout()"
  >
    <div class="btn-group" role="group" aria-label="...">
      @for (button of buttons; track button; let isLast = $last) {
        <div>
          <button
            type="button"
            class="btn btn-default"
            (click)="onButtonPressed(button)"
          >
            <svg-icon-sprite
              src="assets/svg/sprite.svg#{{ button.icon }}"
              [viewBox]="'0 0 24 24'"
              [width]="'14px'"
            >
            </svg-icon-sprite>
          </button>
          @if (!isLast) {
            <div class="vertical-divider"></div>
          }
        </div>
      }
    </div>
  </ul>
</div>
